import { IconTypesProps } from '@/ui/components/svg/iconTypes'
import { Circle, Path, Svg } from '@react-pdf/renderer'

const SvgStatusModerate = ({ primaryColor = '#F0F0F0' }: IconTypesProps) => (
    <Svg width="20" height="20" viewBox="0 0 24 24">
        <Circle cx="12" cy="12" r="12" fill="#EADB03" />
        <Path
            d="M9.59961 15.4498L11.9996 13.0498L14.3996 15.4498L11.9996 17.8498L9.59961 15.4498Z"
            fill={primaryColor}
        />
        <Path
            d="M9.59961 8.5499L11.9996 6.1499L14.3996 8.5499L11.9996 10.9499L9.59961 8.5499Z"
            fill={primaryColor}
        />
    </Svg>
)

export default SvgStatusModerate
